export default __webpack_public_path__ + "static/media/colton.c68b4a65.webp";